<template>
    <div class="menu">
      <div class="nav-items">
        <ul class="menu-items">
          <MenuItem target="home" :active="mainMenuTab === 'home'" icon-name="icon-home" @click="clickMenuItem" title="Hjem"/>
          <MenuItem target="content" :active="mainMenuTab === 'content'" icon-name="icon-content" @click="clickMenuItem" title="Meny"/>
          <MenuItem target="edit" :active="mainMenuTab === 'edit'" icon-name="icon-edit" @click="clickMenuItem" title="Tegninger"/>
          <MenuItem target="fav" :active="mainMenuTab === 'fav'" icon-name="icon-fav" @click="clickMenuItem" title="Favoritter" />
          <MenuItem target="info" v-if="showInfo" :active="mainMenuTab === 'info'" icon-name="icon-info" @click="clickMenuItem" title="Informasjon" />
        </ul>
        <div class="brand-closed"><img src="@/assets/brand_hvit.svg" alt="logo" /></div>
      </div>
      <div class="menu-tabs">
        <div class="menu-tab" id="home" v-if="mainMenuTab === 'home'">
          <div class="menu-tab-content main">
            <p>Hei, {{ user.sub }}!</p>
            <p>&nbsp;</p>
            <p><a href="https://www.cappelendammundervisning.no/cdu/mypage/mypage.action#/products" target="_blank">Min side</a></p>
            <!-- <p>Hjelp</p>
            <p>Innstillinger</p> -->
            <p><a href="#" @click.prevent="showPrivacy">Personvern</a></p>
            <!-- ikke vise logout link hvis login kom fra skolen med jwt -->
            <p v-if="showLogout" ><router-link :to="{name: 'Logout'}">Logg ut</router-link></p>
          </div>
          <div class="brand"><img src="@/assets/brand_hvit.svg" alt="logo" /></div>
        </div>
        <keep-alive>
          <ContentMenuTab v-if="mainMenuTab === 'content'" />
          <PageDrawTab v-else-if="mainMenuTab === 'edit'" />
          <PageFavTab v-else-if="mainMenuTab === 'fav'" />
          <PageInfoTab v-else-if="mainMenuTab === 'info'" />
        </keep-alive>
      </div>
    </div>
</template>

<script>
import ContentMenuTab from './ContentMenuTab'
import PageFavTab from './PageFavTab'
import PageDrawTab from './PageDrawTab'
import PageInfoTab from './PageInfoTab'
import MenuItem from './MenuItem'
import { mapGetters } from 'vuex'
import store from '@/store'

export default {
  data () {
    return {
      open: false,
      mainMenuTab: '',
      showLogout: store.getters.loginOrigin !== 'jwt'
    }
  },
  methods: {
    clickMenuItem (target) {
      this.mainMenuTab = target
      if (this.open && target === 'home') {
        this.open = false
      } else {
        this.open = true
      }
    },
    documentClick (event) {
      const el = this.$el
      const target = event.target
      if (el !== target && !el.contains(target)) {
        this.open = false
      }
    },
    showPrivacy (event) {
      this.$store.dispatch('showPrivacy')
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser',
      spread: 'spread',
      oddPage: 'oddPage',
      evenPage: 'evenPage',
      currentPage: 'currentPage'
    }),
    showInfo () {
      if (this.spread) {
        return (this.evenPage !== null && this.evenPage.description !== null) || (this.oddPage !== null && this.oddPage.description !== null)
      } else {
        return this.currentPage.description !== null
      }
    }
  },
  watch: {
    open (newVal, oldVal) {
      const el = this.$el
      if (newVal) {
        el.classList.add('open')
      } else {
        el.classList.remove('open')
      }
      this.$store.commit('toggleLeftMenu')
    }
  },
  components: {
    ContentMenuTab,
    MenuItem,
    PageFavTab,
    PageDrawTab,
    PageInfoTab
  }
}
</script>

<style>

</style>
